$(document).ready(function() {
  var images = $(".product__media-item");
  var isSwapped = false;

  $(".custom-rotate-button button").on("click", function() {
    console.log('clicked');
    if (isSwapped) {
      console.log('isSwapped')
      gsap.to(images.eq(0), { scale: 1.205, x: 0, z: 67, rotationY: 0, duration: 0.5 }); // Reduced 'z' value
      // third click, this happens:
      gsap.to(images.eq(1), { scale: 0.95, x: 122, z: 67, y: -11, rotationY: 0, duration: 0.5 }); // Reduced 'x' and 'z' values
    } else {
      console.log('isSwapped is false')
      // first one is done
      gsap.to(images.eq(0), { scale: 0.95, x: -135, z: 67, y: -5, rotationY: 0, duration: 0.5 }); // Reduced 'x' and 'z' values
      gsap.to(images.eq(1), { scale: 1.205, x: 10, z: 75, rotationY: 0, duration: 0.5 }); // Reduced 'z' value
    }
    isSwapped = !isSwapped;
  });
});


